import { Box, Grid } from '@mui/material';
import { ReactElement } from 'react';
import { useAppTheme } from '../../context/ThemeContext';

const AuthWrapper = ({ children }: { children: ReactElement }) => {
  const { isNewTheme, accentColor } = useAppTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        ...(isNewTheme
          ? {
              background: '#F8FAFC',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: '-15%',
                right: '-8%',
                width: '480px',
                height: '480px',
                borderRadius: '50%',
                backgroundColor: `${accentColor}0d`,
                pointerEvents: 'none',
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '-12%',
                left: '-6%',
                width: '360px',
                height: '360px',
                borderRadius: '50%',
                backgroundColor: 'rgba(15,23,42,0.04)',
                pointerEvents: 'none',
              },
            }
          : {
              backgroundColor: '#fafafb',
            }),
      }}>
      <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
        <Grid item>{children}</Grid>
      </Grid>
    </Box>
  );
};

export default AuthWrapper;
